<template>
  <div class="gh-question">
    <div v-if="question.leadingText" class="gh-question__content leading-text" v-html="question.leadingText">
    </div>
    <div class="gh-question__content">
      <div class="gh-question__statement">
        <span class="order">Question {{ question.orderIndex }}:</span>
        <div class="statement" v-html="question.statement"></div>
      </div>

      <gh-reveal-slide :scroll-on-completed="false" :duration="0.5">
        <div class="gh-question__choices" v-if="visibleChoices || completed">
          <el-radio-group v-model="memberChoice" :disabled="isCorrectAnswer || completed">
            <el-radio v-for="choice in sortChoices(question.choices)" :key="choice.id" :label="choice.prefix">
              <strong class="choice__prefix">{{ choice.prefix }}.</strong>
              <span class="choice__statement" v-html="choice.statement"></span>
            </el-radio>
          </el-radio-group>
        </div>
      </gh-reveal-slide>

      <div class="gh-question__actions">
        <el-button v-if="!completed" :class="actionButtonClass" @click="handleClickButton" :disabled="! memberChoice" v-loading="isProcessing">
          {{ actionButtonLabel }}
        </el-button>
        <el-tag v-if="isSaved" class="gh-tag" :color="tagColor">{{ tagLabel }}</el-tag>
      </div>

      <div class="gh-question__hint" v-if="showCorrectAnswer">
        <p>Correct answer is: <span class="correct-answer">{{ question.correctAnswer }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slug: {
        type: String,
        required: true
      },

      moduleOrder: {
        type: [String, Number],
        required: true
      },

      question: {
        required: true,
        type: Object
      },

      memberUnit: {
        required: true,
        type: Object
      },

      showCorrectAnswer: {
        type: Boolean,
        default: false
      },

      completed : {
        type: Boolean,
        default: false
      },

      assessmentStatus: {
        type: String
      }
    },

    data() {
      return {
        memberChoice: this.memberAnswer,
        isSaved: !!this.memberAnswer,
        visibleChoices: true,
        isProcessing: false
      }
    },

    computed: {
      memberAnswer() {
        return this.memberUnit.answers[this.question.orderIndex]
      },

      isCorrectAnswer () {
        return this.assessmentStatus !== 'inProgress' && this.memberAnswer === this.question.correctAnswer
      },

      actionButtonClass() {
        const modifier = this.visibleChoices ? 'gh-button--cta' : 'gh-button--silver';

        return ['gh-button', modifier];
      },

      actionButtonLabel() {
        if (this.isCorrectAnswer) {
          return this.visibleChoices ? 'Close' : 'Open';
        }

        return this.visibleChoices ? 'Save Progress' : 'Edit Answer';
      },

      tagColor() {
        if (this.assessmentStatus === 'inProgress') return '#514a9d';

        return this.isCorrectAnswer ? '#13ce66' : '#dc3a24';
      },

      tagLabel() {
        if (this.assessmentStatus === 'inProgress') return 'Saved';

        return this.isCorrectAnswer ? 'Your answer is correct' : 'Your answer is incorrect';
      },

      mustResubmit() {
        return this.assessmentStatus === 'notCompetent';
      }
    },

    methods: {
      sortChoices(choices) {
        return _.orderBy(choices, ['prefix'], ['asc'])
      },

      handleClickButton() {
        if (!this.memberChoice || this.isProcessing) {
          return false;
        }

        if (this.isSaved || this.isCorrectAnswer) {
          this.toggleChoicesVisibility();
          return false;
        }

        this.saveAnswer();
      },

      toggleChoicesVisibility(state = undefined) {
        this.visibleChoices = state || !this.visibleChoices;
      },

      saveAnswer() {
        this.isProcessing = true;
        this.$store.dispatch('credential/updateMemberUnitAssessment', {
          slug: this.slug,
          moduleOrder: this.moduleOrder,
          memberUnit: this.memberUnit,
          answers: { [this.question.orderIndex]: this.memberChoice }
        })
          .then(() => {
            this.$emit('saved')
            this.toggleChoicesVisibility();
            this.isSaved = !this.mustResubmit;
            this.isProcessing = false;
            this.$message({
              message: 'Your answer has been saved!',
              type: 'success'
            });
          })
          .catch(error => {
            this.isProcessing = false;
            this.isSaved = false;
            this.visibleChoices = true;
          });
      }
    },

    watch: {
      memberChoice(newValue, oldValue) {
        this.isSaved = this.memberAnswer && newValue === this.memberAnswer;
      },

      memberAnswer: {
        immediate: true,
        handler: function(value) {
          this.memberChoice = value
        }
      },

      isSaved: {
        immediate: true,
        handler: function(value) {
          if (value) {
            this.visibleChoices = false
          }
        }
      },
    }
  }
</script>
